// @ts-check
import { Trans } from '@lingui/macro';
import { useHistory } from 'react-router-dom';
import { Flex, SkeletonText } from '~/design-system';
import Footer, {
  BackButton,
  CancelButton,
  NextButton,
} from '../../../../components/Layout/Footer';
import Layout from '../../../../components/Layout/Layout';
import Main from '../../../../components/Layout/Main';
import {
  PageHeader,
  PageSubtitle,
  PageTitle,
} from '../../../../components/Layout/PageHeader';
import MapValues from '../../../../components/MapValues/MapValues';
import { ProgressIndicator, useLink } from './_config';

import { useMapValues } from '../../../../components/MapValues/MapValues';

export default function MapValuesPage({ match }) {
  const link = useLink('mapValues');
  const history = useHistory();

  const props = useMapValues({
    workspaceId: match.params.workspaceId,
    importId: match.params.importId,
  });

  // We should skip this step if there are no source fields
  // that should be mapped
  if (props.sourceFields?.length === 0) {
    history.push(link.next());
  }

  return (
    <Layout>
      <ProgressIndicator step="mapData" />
      <PageHeader>
        <PageTitle>
          <Trans>Map field values</Trans>
        </PageTitle>
        <PageSubtitle>
          <Trans>
            Choose the Bottlebooks values that best matches with your data.
          </Trans>
        </PageSubtitle>
      </PageHeader>
      <Main>
        {props.loading ? (
          <Flex sx={{ justifyContent: 'space-around' }}>
            <SkeletonText width={100} />
          </Flex>
        ) : (
          <MapValues sx={{ marginBottom: 7 }} {...props} />
        )}
      </Main>
      <Footer>
        <BackButton to={link.back()} />
        <CancelButton to={link.cancel()} />
        <NextButton
          onClick={async () => {
            const result = await props.updateValuesMapping();
            if (!result?.error) history.push(link.next());
          }}
          disabled={!props.isValid}
        />
      </Footer>
    </Layout>
  );
}
